import React, { Fragment } from 'react';
import anime from 'animejs';
import {
  isMobilePhone,
  isMobileTablet,
  doWhenReady,
  isSelectorValid,
  isAndroidPhone,
} from '../../library/calc';

import { minMilisec4TouchHold,
         exitMobileFlipCardScale,
         isDevelopment,
         userIsLoggedIn,
         maxZoom,
         minZoom,
         slideUpImmediateHeight,
         slideUpAddSourceCitationHeight,
         slideUpImmediateMoveNavPercentUp,
         slideUpAddSourceCitationMoveNavPercentUp,
         isSeinfeld,
         bottomSaveBarForMobileSourceCitation,
         isRtl,
         imageBasePath,
         showPrintTree,
         hasTreeActivationBanner,
         hasExpiringProUpsell,
         mobileButtonDim,
         minimal,  // bookmarkPleaseRemove minimal
} from '../../library/constants';

import {
  Flipcard,
  PreferencesMobile,
  PrintFlipcardMobile,
  SlideUpImmediateFam,
  SlideUpAddSourceCitation,
  ConfirmMobile,
} from './codesplitting';


import SwitchTree from '../../components/SwitchTree';
import PrintTreeIcon from '../../components/PrintTree/icon';
import { HelpIcon } from '../../components/ProductTour/icon';

import Base from './2_base';


class Mobile extends Base {

  /*

    Note: Instead of using tap event... using touch instead.  Touch used when user is pinch drag. If there is no
    distance between first and last touch... we can safely assume this is a tap.  When node is touchend... then
    it calls userTouchedNode, to pass in node_id to instance property nodeForFlipFocus..
    then calls panAnimateToNode... to fly the user to touch node.

    We do this hack because sometimes users will want to drag by dragging a node. They can do that or touch a node.

  */

  zoomOutFromMobileFlipCard({
    node,
    showMatchBubble,
    yShift,
    callback,
    foo,
    panToNodeCallback4Mobile,
    zoomOutFromMobileFlipCardCallback,
    callbackAfterGotoHashNode,
  }){
    if(typeof(foo) !== 'undefined') foo();
    this.setState({
      nodeForFlipFocus: null,
      showMobileFlipCard: false,
      modalIsDisplayed: false,
    });
    this.showFlipNodeMobileAfterZoomIn = false;
    this.disableTouchmove();
    const targetScale = exitMobileFlipCardScale;
    // this.panAnimateToNode({ node, targetScale, showMatchBubble, yShift, callback } );
    this.zoomAnimateToNode({ node,
      targetScale,
      showMatchBubble,
      yShift,
      callback,
      panToNodeCallback4Mobile,
      zoomOutFromMobileFlipCardCallback,
      callbackAfterGotoHashNode,
    })
  }

  userIsExitingFlipCard(){
    return isMobilePhone() && this.state.showMobileFlipCard;
  }

  userTouchedCycle({ node, callback, fromWhere }){

    console.log('Touch is coming from: ' + fromWhere);

    this.clearAllAnimations({fromWhere: 'userTouchedNode'});
    if(!userIsLoggedIn) return;
    this.continueWithTouchSpot = true;

    if(typeof(callback) !== 'undefined'){

      this.callbackForUsertouch = callback;
      this.fromWhere = fromWhere;
    }

  }

  userTouchedNode({ node, callback, fromWhere }){

    // console.log('Touch is coming from: ' + fromWhere);
    // console.log(JSON.stringify({node, callback, fromWhere}, null, 2));
    // console.log(`callback: `, callback);

    this.clearAllAnimations({fromWhere: 'userTouchedNode'});
    this.hideNotificationModal({});

    /**
     *
     *  When user touches a node, we are only designating node in state.nodeForFlipFocus
     *  We are relying in staging touch event to continue.
     *  Stage touch will distinguish between single and multi touch
     *  then further dinstingish a drag from a touch base on start and end distance
     *
     */

    if(!userIsLoggedIn && !isDevelopment) return;
    /*
    *
    *
    * Continues at the end of touchDragEnd() if continueWithTouchSpot === true
    *
    *
    */

    this.continueWithTouchSpot = true;

    if(typeof(callback) !== 'undefined'){
      this.callbackForUsertouch = callback;
      this.fromWhere = fromWhere;
    }


  }

  userTouchedOutsideNode(){
   if(isMobileTablet()) return;
   this.hideMatchBubble();
   //this.zoomInOutStepping({});
  }

  userTouchedWithCallback(){
    // console.log('userTouch coming from: ', this.fromWhere);
    this.callbackForUsertouch();
    this.callbackForUsertouch = undefined;
  }

  isTouchSpot(changeInDistX, changeInDistY){
    const scale = this.stage.current.scaleX();
    if(isMobilePhone()) return Math.round((Math.abs(changeInDistX) / scale)/4) === 0
    if(isMobileTablet()) return Math.abs(changeInDistX) === 0 && Math.abs(changeInDistY) === 0
  }

  touchDragEnd(event){
    if(isDevelopment  || isSeinfeld) document.getElementById("debugDiv1").innerHTML = `touchDragEnd`;
    if(isDevelopment  || isSeinfeld) document.getElementById("debugDiv0").innerHTML = `touchDragEnd`;

    const stopMiliSec = Date.now();
    const changeInTime = stopMiliSec - this.startMiliSec;
    const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
    const endTouchX = touches[0].clientX;
    const endTouchY = touches[0].clientY;
    const changeInDistX = this.startTouchX - endTouchX;
    const changeInDistY = this.startTouchY - endTouchY;
    // const direction = ( changeInDistX >= 0 ? -1 : 1);
    // const scale = this.stage.current.scaleX();
    // const scaledChangeInDist = Math.round((Math.abs(changeInDistX) / scale)/4);

    // console.log('this.startTouchX: ' + this.startTouchX);
    // console.log('endTouchX: ' + endTouchX);
    // console.log('this.startTouchY: ' + this.startTouchY);
    // console.log('endTouchY: ' + endTouchY);
    // console.log('this.startTouchX: ' + this.startTouchX);
    // console.log('scaledChangeInDist: ' + scaledChangeInDist);
    // console.log('changeInTime: ' + changeInTime);
    // console.log('> Math.abs(changeInDistX): ' + Math.abs(changeInDistX));
    // console.log('> Math.abs(changeInDistY): ' + Math.abs(changeInDistY));

    // Assumed that when no touch dragged distance then
    // call pan and zoom (this.panAnimateToNode) to the node that was touched
    // if(Math.abs(changeInDistX) === 0 && Math.abs(changeInDistY) === 0 ) {

    if(this.isTouchSpot(changeInDistX, changeInDistY)) {
      if(this.continueWithTouchSpot) {

        this.continueWithTouchSpot = false;
        const node = this.state.nodeForFlipFocus;

        if(typeof(this.callbackForUsertouch) !== 'undefined'){

          if(isDevelopment || isSeinfeld) document.getElementById("debugDiv2").innerHTML = `node: ${node}`;
          this.userTouchedWithCallback(node);
          return;
        }

      } else {
        if(isDevelopment  || isSeinfeld) document.getElementById("debugDiv1").innerHTML = `Touched`;
        // console.log('User touched canvas');
        this.userTouchedOutsideNode();
      }

      return;
    }

    // console.log('was dragged.');

    this.continueWithTouchSpot = false;
    // this.isZooming = false;

    /**
      *
      *
      *   User has swipped or dragged canvas
      *
      *
      *
     */


    if(changeInTime < minMilisec4TouchHold) {

      this.calcNewStageCenterNodePos();
      this.redraw({});

      // if(isMobilePhone()) this.velocityMove('horizontal', direction, scaledChangeInDist, changeInTime);
    } else {
      this.calcNewStageCenterNodePos();
      this.redraw({});
    }
  }

  getTouchPinchingScale(touches){

    const distanceBetweenXtouches = touches[0].clientX - touches[1].clientX;
    const distanceBetweenYtouches = touches[0].clientY - touches[1].clientY;

    const pinchDistance  = Math.sqrt(distanceBetweenXtouches * distanceBetweenXtouches +
                                     distanceBetweenYtouches * distanceBetweenYtouches);

    return pinchDistance / this.startPinchDistance * this.touchStartScale;

  }

  disableTouchMoveForSplitSec(){
    this.touchMoveDisabled = true;
    setTimeout(() => {
      this.touchMoveDisabled = false;
    }, 600);
  }

  disableTouchmove(){
    // console.log('disabling touchmove');
    // this.stage.draggable(false);
    this.touchMoveDisabled = true;
  }

  enableTouchmove(){
    // console.log('enabling touchmove');
    // this.stage.draggable(true);
    this.touchMoveDisabled = false;
  }

  setFlipCardScreenIsOn({screenIsOn}){
    this.setState({flipCardScreenIsOn: screenIsOn});
  }

  setShowMobileFlipCard(node){

    if(this.isNoViewProfile(node)){
      console.log('do not open');
      return;
    }

    if(!isDevelopment && this.state.flipCardScreenIsOn === 'mainFromHome' && node > 0) {
      const pr_id = this.props.nodeObjs[node].pr_id;
      this.props.fetchFlipData({pr_id, node});
    }
    this.setState({  showMobileFlipCard: true});

    this.disableTouchmove();

  }

  unsetShowMobileFlipCard(){
    this.setState({  showMobileFlipCard: false, });
    this.enableTouchmove();
  }

  showMobileFlipCard(){
    this.setState({  showMobileFlipCard: true, });
  }

  callShowModal(){
    const whichModalScreen = `Preferences`;
    this.showModal({whichModalScreen});
  }

  bindMobileEvents(){

    // if(dualPedigreeMode) return;

    if(isMobilePhone() ){

      window.forceHideMoreList = () => {
        return null;
      }

      if( userIsLoggedIn && !isDevelopment) {

        let preferencesStr = 'Preferences'

        if( typeof(window.trl) !== 'undefined' ){
          preferencesStr = window.trl('Preferences', 'Displays tree preferences');
        }

        if (typeof window.addMenuItem === 'function') {
          window.addMenuItem(preferencesStr, () => {
            const whichModalScreen = "Preferences";
            window.closeMenu();
            this.showModal({ whichModalScreen });
          });
        } else {
          console.error('addMenuItem function is not defined on the window object');
        }

      }

    }

    if(isMobilePhone() || isMobileTablet()){

      // TOUCH PINCH ZOOM OR DRAG

      this.stage.current.container().addEventListener('touchstart', (event) => {

        if(isDevelopment || isSeinfeld) document.getElementById("debugDiv3").innerHTML = `touchstart`;

        /* NOTE

          event.preventDefault() works to stop Safari touchevents from pinching browser

         */

        event.preventDefault();

        if(typeof(window.closeMenu) !== 'undefined') {
          window.closeMenu();  // External call to close Geni hamburger menu
        }

        if(this.touchMoveDisabled) {
          console.log('Touchmove was disabled...  touchstart');
          return;
        }

        this.clearAllAnimations({fromWhere: 'stage touchstart'});

        const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;

        if (touches.length === 2) {

          this.isPinching = true;

          const distanceBetweenXtouches = touches[0].clientX - touches[1].clientX;
          const distanceBetweenYtouches = touches[0].clientY - touches[1].clientY;

          this.startPinchDistance = Math.sqrt(distanceBetweenXtouches * distanceBetweenXtouches +
                                              distanceBetweenYtouches * distanceBetweenYtouches);
        } else{

          this.isPinching = false;
          this.startMiliSec = Date.now();
          this.startTouchX = touches[0].clientX;
          this.startTouchY = touches[0].clientY;

        }

        return false;
      }, true);

      this.stage.current.container().addEventListener('touchmove', (event) => {

        if(isDevelopment || isSeinfeld) document.getElementById("debugDiv2").innerHTML = `touchmove`;

        if(this.touchMoveDisabled) {
          console.log('Touchmove was disabled...  touchstart');
          return;
        }

        const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;

        this.stage.current.draggable(true);

        if (touches.length === 2) { // PINCHING

          this.stage.current.draggable(false);

          const touchPinchingScale = this.getTouchPinchingScale(touches);

          if(touchPinchingScale < minZoom || touchPinchingScale > maxZoom) return;

          this.stage.current.scale({ x: touchPinchingScale, y: touchPinchingScale });

          this.stage.current.position({
            x: this.getCurStagePos().x,
            y: this.getCurStagePos().y
          });

          this.stage.current.batchDraw();

          this.touchPinchingScale = touchPinchingScale;

        } else{

          // console.log('Touch moving');
          // this.stage.draggable(true);

        }
        return false;
      }, true);


      this.stage.current.container().addEventListener('touchend', (event) => {

        if(this.touchMoveDisabled) {
          console.log('Touchmove was disabled...  touchstart');
          return;
        }

        if(this.stageCanBeClickedTouchedHovered) {
          if( this.matchBubbleAppears ) {
            console.log('will hide matchbubble ... ');
            this.hideMatchBubble();
          }

          if(isMobileTablet() && this.state.flipPanelOpened && this.props.chartType !== 'fan') {
            this.toggleFlipPanel({close: true, from: 'touchstart'});
          }

        }

        if(typeof(this.touchPinchingScale) !== 'undefined') {
          this.touchStartScale = this.touchPinchingScale;
        }

        if(this.isPinching){
          this.cleanUp({closePedigreeAddbox: true});
          console.log('Scale after pinch: ' + this.stage.current.scaleX());
          this.redraw({});
        } else {
          // console.log('Touch end');
          this.touchDragEnd(event);
        }

        this.stage.current.draggable(true);
        return false;
      });

      // END TOUCH PINCH ZOOM OR DRAG

      this.stage.current.container().addEventListener('dblTap', (e) => {
      });

    } // END if mobile

  }

  disableSwipeToMoveFowardOrBackward(){ // https://stackoverflow.com/questions/30636930/disable-web-page-navigation-on-swipeback-and-forward

    console.log(`disableSwipeToMoveFowardOrBackward is running`);

    var xPos = null;
    var yPos = null;
    window.addEventListener( "touchmove", function ( event ) {
        var touch = event.originalEvent.touches[ 0 ];
        var oldX = xPos;
        var oldY = yPos;
        xPos = touch.pageX;
        yPos = touch.pageY;
        if ( oldX == null && oldY == null ) {
            return false;
        }
        else {
            if ( Math.abs( oldX-xPos ) > Math.abs( oldY-yPos ) ) {
                event.preventDefault();
                return false;
            }
        }
    } );
  }

  setShowSlideUpImmediateFamily({how}){
    this.setState({
      showSlideUpImmediateFamily: how
    });
  }

  slideUpImmediateIsUp = false;

  slideUpImmediatePanel({direction, toggle}){

    let going = undefined
    if(typeof(toggle) !== 'undefined'){
      if(this.slideUpImmediateIsUp){
        going = 1;
        this.slideUpImmediateIsUp = false;
      } else {
        going = -1;
        this.slideUpImmediateIsUp = true;
      }
    } else {
      if(direction === 'up'){
        going = -1;
        this.slideUpImmediateIsUp = true;
      } else{
        this.slideUpImmediateIsUp = false;
        going = 1;
      }
    }

    let delay = 500;
    const duration = 400;

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['#slideup-immediatefam-panel'],
      translateY: going * (slideUpImmediateHeight/slideUpImmediateMoveNavPercentUp),
    });

  }

  addNewFamilyProfileForCitations(){
    const whenAddNewFamilyProfileForCitations = () => {
      return document.querySelector('.add_unmatched_profile') != null;
    }

    const adaptStylesAddSourceCitationModal = () => {

      const addUnmatchedProfile = document.querySelectorAll('.add_unmatched_profile');
      addUnmatchedProfile.forEach((element)=>{

        const marginPx = -1 * (window.innerHeight/2);
        element.style.setProperty("margin", `${ marginPx }px -6px`, "important");
        element.style.setProperty("width", `${window.innerWidth}px`, "important");
        element.style.setProperty("padding", "5px 0px 10px 0px", "important");
        element.style.setProperty("border-radius", "0px", "important");

      });

      this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.quick_add_field_labels', cssProp: 'width', pxStr: `${(window.innerWidth/4) - 10}px`});
      this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.quick_add_field_labels', cssProp: "margin-left", pxStr: `${(window.innerWidth/4) - 10}px`});

      this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.qa_name_fields', cssProp: 'width', pxStr: `${(window.innerWidth/4) - 10}px`});
      this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.qa_name_fields', cssProp: "margin-right", pxStr: `${(window.innerWidth/4) - 10}px`});

      const quickAddFields = document.querySelectorAll('.quick_add_fields');
      quickAddFields.forEach((element)=>{
          element.style.setProperty("margin-left", `initial`, "important");
      });

      document.querySelector('#qa_names').style.setProperty("position", "relative", "important");
      document.querySelector('#qa_names').style.setProperty("float", "left", "important");
      document.querySelector('#qa_names').style.setProperty("width", "100%", "important");

      document.querySelector('#qa_gender_and_living_status').style.setProperty("position", "relative", "important");
      document.querySelector('#qa_gender_and_living_status').style.setProperty("float", "left", "important");
      document.querySelector('#qa_gender_and_living_status').style.setProperty("width", "100%", "important");


    }

    doWhenReady({argument: '', condition: whenAddNewFamilyProfileForCitations, callback: adaptStylesAddSourceCitationModal, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})

  }

  elongateChildrenListContainer(){

    const whenElongateChildrenListContainer = () => {
      return document.querySelector('#children_list') != null;
    }

    const adaptElongateChildrenListContainer = () => {

      const childrenList = document.querySelectorAll('.children_list_container');
      childrenList.forEach((element)=>{
          // element.style.setProperty("height", `${window.innerHeight -  bottomSaveBarForMobileSourceCitation - 300}px`, "important");
          element.style.setProperty("max-height", "initial", "important");
          element.style.setProperty("height", `auto`, "important");
          element.style.setProperty("border", `initial`, "important");
      });

      const field_name_label = document.querySelectorAll('.field_name_label');
      field_name_label.forEach((element)=>{
          element.style.setProperty("display", `table`, "important");
      });

    }

    doWhenReady({argument: '', condition: whenElongateChildrenListContainer, callback: adaptElongateChildrenListContainer, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})

  }

  setShowSlideUpAddSourceCitation({how}){
    this.setState({
      showSlideUpAddSourceCitation: how
    });
  }

  animateScrollTopToBottomFileInputContainer({first}){

    document.querySelector('#document_form').style.setProperty("width", "100%", "important");

    if(first && isAndroidPhone()){
      const innerPPadding = document.querySelectorAll('#document_form .inner p');
      innerPPadding.forEach((element)=>{
          element.style.setProperty("overflow", `hidden`, "important");
          window.jQuery(element).animate({height: 0}, 800, function() {
            element.style.setProperty("display", `none`, "important");
          });
      });
    } else {


      const fileInputWrapper = document.querySelector('#file_input_wrapper');
      const fileInputWrapperHeight = parseInt(window.getComputedStyle(fileInputWrapper).getPropertyValue('height'), 10);

      window.jQuery('#file_input_container').animate({ scrollTop: fileInputWrapperHeight}, 1000);
    }

    if(isAndroidPhone()){
      this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'#file_input_container', cssProp: 'height', pxStr: `${(window.innerHeight/3)}px`});
    }

  }

  translateYModalLightBox = 43;
  slideUpAddSourceCitationIsUp = false;

  slideUpAddSourceCitationPanel({direction, toggle, prId, fromWhere}){

    // console.log(`fromWhere: `, fromWhere);
    // console.log(`direction: `, direction);
    // console.log(`toggle: `, toggle);

    let going = undefined
    if(typeof(toggle) !== 'undefined'){
      if(this.slideUpAddSourceCitationIsUp){
        going = 1;
        this.slideUpAddSourceCitationIsUp = false;
      } else {
        going = -1;
        this.slideUpAddSourceCitationIsUp = true;
      }
    } else {
      if(direction === 'up'){
        going = -1;
        this.slideUpAddSourceCitationIsUp = true;
      } else{
        this.slideUpAddSourceCitationIsUp = false;
        going = 1;
      }
    }

    const distanceShiftY = slideUpAddSourceCitationHeight/slideUpAddSourceCitationMoveNavPercentUp
    let delay = 500;
    const duration = 400;
    let translateY = going * (distanceShiftY);
    translateY = translateY.toFixed(3)

    if(going === -1) {

      anime({
        easing: 'easeInOutQuart',
        duration,
        delay,
        targets: ['#slideup-addSourceCitation-panel'],
        translateY,
      });

      anime({
        easing: 'easeInOutQuart',
        duration,
        delay: 0,
        targets: ['.modal_lightbox'],
        translateY: this.translateYModalLightBox,
      });

      document.getElementById('slideup-addSourceCitation-panel').style.zIndex = '9007';
      if(isDevelopment)  return;
      setTimeout(() => {

          setTimeout(() => {

            if(isRtl){

              document.querySelector("#document_form") && document.querySelector("#document_form").style.setProperty("float", `initial`, "important");

            }

            document.getElementById('slideup-addSourceCitation-panel').style.zIndex = '9004';
            document.getElementById('add_document_modal').parentElement.style.zIndex = '9005';
            document.querySelector('#add_document_modal').parentElement.style.setProperty("top", "100px", "important");
            document.querySelector('#add_document_modal').parentElement.style.setProperty("background", "#f5f5f5", "important");
            document.querySelector('.modal_bd').parentElement.style.setProperty("border", "solid 1px #f5f5f5", "important");

            const addDocModalFt = document.querySelectorAll('#add_document_modal .modal_ft');
            addDocModalFt.forEach((element)=>{
                element.style.setProperty("bottom", `${220}px`, "important");
            });

            if( isAndroidPhone()){

              const innerPPadding = document.querySelectorAll('#document_form .inner p');
              innerPPadding.forEach((element)=>{
                  element.style.setProperty("padding", `9px ${window.innerWidth/7}px 10px 15px`, "important");
              });

            } else {

              const innerPPadding = document.querySelectorAll('#document_form .inner p');
              innerPPadding.forEach((element)=>{
                  element.style.setProperty("padding", `15px ${window.innerWidth/7}px 15px 15px`, "important");
              });
            }

            document.querySelector('.modal_lightbox').style.setProperty("transform", "translateY(10px)");

            this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'#form_document .xxlong_input', cssProp: 'width', pxStr: `${(window.innerWidth/1.5)}px`});
            this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'#simple_upload .field_bd span', cssProp: 'width', pxStr: `${(window.innerWidth/1.5)}px`});
            this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'#form_document .xlong_input', cssProp: 'width', pxStr: `${(window.innerWidth/1.5)}px`});

            this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'#file_input_container', cssProp: 'height', pxStr: `${(window.innerHeight/5)}px`});

            // console.log(`document.querySelector('.modal_lightbox').style: `, document.querySelector('.modal_lightbox').style);

            // document.querySelector('#upload_buttons > span').style.setProperty("display", "none", "important");
            // document.querySelector('#upload_buttons .panel_action').style.setProperty("display", "none", "important");

          }, 1000);

          if( typeof(prId) !== 'undefined' ) window.openDocs('upload', {reset_docs: true, class_and_id:`profile-${prId}`, origin:'citations_lb'});

      }, delay * 2);

    } else {

        if(isDevelopment)  return;
        if( typeof(prId) !== 'undefined' ) window.openDocs('cite', {reset_docs: true, class_and_id:`profile-${prId}`,origin:'citations_lb'});

        const whenMediaSelectorLoaded = () => {

          return document.getElementById('select_and_cite_modal') != null;
        }

        const adaptStylesAddSourceCitationModal = () => {

          window.callSetAddSourcePanelOpen({addSourcePanelOpen: false})

          anime({
            easing: 'easeInOutQuart',
            duration,
            delay,
            targets: ['#slideup-addSourceCitation-panel'],
            translateY,
          });

          anime({
            easing: 'easeInOutQuart',
            duration,
            delay: delay * 2,
            targets: ['.modal_lightbox'],
            translateY: this.translateYModalLightBox * -1,
          });


          if(isRtl){
            document.querySelector ('#fact_container div:nth-of-type(1)').style.setProperty("float", `left`, "important");
            document.querySelector ('#fact_container div:nth-of-type(1)').style.setProperty("float", `left`, "important");
            document.querySelector ('#fact_container select').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container span.tagged_only').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container input[type="checkbox"]').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container .info[data-icon]').style.setProperty("float", `right`, "important");
          }

          document.querySelector('#fact_container div').style.setProperty("width", `${window.innerWidth}px`, "important");
          document.querySelector('#selected_document_update_panel').style.setProperty("width", `${window.innerWidth}px`, "important");
          document.querySelector('#add_new_document_button').style.setProperty("display", "none", "important");

          document.querySelector('#select_and_cite_modal').style.setProperty("opacity", 1);
          document.querySelector('.modal_lightbox').style.setProperty("width", "1000vw", "important");


          document.querySelector('.modal_lightbox').style.setProperty("width", "1000vw", "important");

        }

        doWhenReady({argument: '', condition: whenMediaSelectorLoaded, callback: adaptStylesAddSourceCitationModal, attempts: {ongoing:0, end: 10}, fromWhere: ''})

    }

  }



  addEventListenerInMobileCitationAdditionalInformation({selector, eventHandler, callback}){
     // if( isSeinfeld)  console.log(`selector: `, selector);
      if( isSelectorValid(selector)){
       // if( isSeinfeld)  console.log(`addEventListener valid: `, 'YES');
        const sourceCitationEl = document.querySelectorAll(selector);
        sourceCitationEl.forEach((element)=>{
          if( !element.hasAttribute('binded-' + eventHandler) ){
           // if( isSeinfeld)  console.log('binding ', selector, 'with', eventHandler);
            element.addEventListener(eventHandler, callback);
            element.setAttribute('binded-' + eventHandler, "true")
          } else {
           // if( isSeinfeld)  console.log(selector, ' already binded with ', eventHandler);
          }
        });

      } else {

       // if( isSeinfeld)  console.log(`addEventListener valid: `, selector, ' No');
      }

  }

  resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector, cssProp, pxStr}){

    if( isSelectorValid(selector)){
      // if(isSeinfeld)if( isSeinfeld)  console.log(`selector: `, selector);
      // if(isSeinfeld)if( isSeinfeld)  console.log(`cssProp: `, cssProp);
       // if( isSeinfeld)  console.log(`resizeDom valid: `, 'YES');
      const sourceCitationEl = document.querySelectorAll(selector);
      sourceCitationEl.forEach((element)=>{
        element.style.setProperty(cssProp, pxStr, "important");
      });
    } else {

       if( isSeinfeld)  console.log(`resizeDom valid: `, selector, ' No');
    }

  }

  slideUpAdditionalInformatioIsUp = false;

  slideUpAdditionalInformatioPanel({direction, toggle, prId, fromWhere}){ //if(Geni.isMobilePhone()) window.callSlideUpAdditionalInformatioPanel({direction: 'down',  fromWhere: 'clearEdit'})

    // console.log(`slideUpAdditionalInformatioPanel fromWhere: `, fromWhere);
    // console.log(`toggle: `, toggle);
    // console.log(`direction: `, direction);

    let going = undefined
    if(typeof(toggle) !== 'undefined'){
      if(this.slideUpAdditionalInformatioIsUp){
        going = 1;
        this.slideUpAdditionalInformatioIsUp = false;
      } else {
        going = -1;
        this.slideUpAdditionalInformatioIsUp = true;
      }
    } else {
      if(direction === 'up'){
        going = -1;
        this.slideUpAdditionalInformatioIsUp = true;
      } else{
        this.slideUpAdditionalInformatioIsUp = false;
        going = 1;
      }
    }

    /*

        let delay = 500;
        const duration = 400;
        const shiftDistance = 0; //100;

        const translateY = going * (shiftDistance);
        anime({
          easing: 'easeInOutQuart',
          duration,
          delay,
          targets: ['#additional_information'],
          translateY,
        });

     */

    if(going === -1) {

      setTimeout(() => {
        const additionalInformation = document.querySelector('#additional_information');
        additionalInformation.style.setProperty("width", `${window.innerWidth}px`);
        let heightAdditionalInformationPanel = parseInt(window.getComputedStyle(additionalInformation).getPropertyValue('height'), 10);
        heightAdditionalInformationPanel += 60;
        const shrinkContainerBy = window.innerHeight -  bottomSaveBarForMobileSourceCitation - heightAdditionalInformationPanel/* citation padding shiftdown */

        // let computedTitleHeight = 0;
        // const titleFact = document.querySelectorAll('#facts_description .strong');
        // titleFact.forEach((element)=>{
        //     computedTitleHeight = getComputedDomValue({element, cssProp: 'height'})
        // });

        window.jQuery('#profile_facts_container').animate({height:`${shrinkContainerBy }`});
        window.jQuery('#relationship_facts_container').animate({height:`${shrinkContainerBy }`});

        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_value input:not([type=radio])', cssProp: 'width', pxStr: `${(window.innerWidth/3 + 25)}px`});
        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_note input:not([type=radio])', cssProp: 'width', pxStr: `${(window.innerWidth/3 + 25)}px`});


        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_value .field_hd', cssProp: 'width', pxStr: `${(window.innerWidth/3 - 50)}px`});
        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_note .field_hd', cssProp: 'width', pxStr: `${(window.innerWidth/3 - 50)}px`});

        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_value select', cssProp: 'width', pxStr: `${(window.innerWidth/3 + 40)}px`});
        this.resizeDomSelectorInMobileCitationAdditionalInformationBasedOnWindowInnerWidth({selector:'.source_citation_note select', cssProp: 'width', pxStr: `${(window.innerWidth/3 + 40)}px`});

        if(isAndroidPhone()){

          const shiftEntryFieldsUp = () => {
            this.slideCitatioForAndroidKeyboard({direction: 'up'})
          }

          const shiftEntryFieldsDown = () => {
            this.slideCitatioForAndroidKeyboard({direction: 'down'})
          }

          this.addEventListenerInMobileCitationAdditionalInformation({selector:'.source_citation_value input:not([type=radio])', eventHandler: 'focusin', callback: shiftEntryFieldsUp});
          this.addEventListenerInMobileCitationAdditionalInformation({selector:'.source_citation_note input:not([type=radio])', eventHandler: 'focusin', callback: shiftEntryFieldsUp});

          this.addEventListenerInMobileCitationAdditionalInformation({selector:'.source_citation_value input:not([type=radio])', eventHandler: 'focusout', callback: shiftEntryFieldsDown});
          this.addEventListenerInMobileCitationAdditionalInformation({selector:'.source_citation_note input:not([type=radio])', eventHandler: 'focusout', callback: shiftEntryFieldsDown});

        }


/*

add_unmatched_profile

 */

/*
        const scrollTop = document.getElementById("profile_facts_container").scrollTop;
        console.log(`scrollTop: `, scrollTop);
        console.log(`shrinkContainerBy: `, shrinkContainerBy);
        if(scrollTop > shrinkContainerBy ){
          document.getElementById("profile_facts_container").scrollBy({
            top: shrinkContainerBy,
            left: 0,
            behavior: 'smooth',
          });
        }
*/

      }, 1000);


    } else {


      // let computedTitleHeight = 0;
      // const titleFact = document.querySelectorAll('#facts_description .strong');
      // titleFact.forEach((element)=>{
      //     computedTitleHeight = getComputedDomValue({element, cssProp: 'height'})
      // });

      window.jQuery('#profile_facts_container').animate({height:`${window.innerHeight -  bottomSaveBarForMobileSourceCitation - 55}`});
      window.jQuery('#relationship_facts_container').animate({height:`${window.innerHeight -  bottomSaveBarForMobileSourceCitation - 55}`});
    }

  }

  adaptRTLForCitations(){

    document.querySelector ('#selected_document_update_panel').style.setProperty("float", `left`, "important");

    const factContainerInput = document.querySelectorAll('#fact_container input[type="checkbox"]');
    factContainerInput.forEach((element)=>{
        element.style.setProperty("float", `right`, "important");
    });

    const profileLabels = document.querySelectorAll('#profile_facts_container .flt_l');
    profileLabels.forEach((element)=>{
        element.style.setProperty("float", `left`, "important");
    });

    const relationshipLabels = document.querySelectorAll('#relationship_details_container .flt_l');
    relationshipLabels.forEach((element)=>{
        element.style.setProperty("float", `left`, "important");
    });

    const partnersLabels = document.querySelectorAll('#partners_container .flt_l');
    partnersLabels.forEach((element)=>{
        element.style.setProperty("float", `left`, "important");
    });

    const childrenLabels = document.querySelectorAll('#children_list .flt_l');
    childrenLabels.forEach((element)=>{
        element.style.setProperty("float", `left`, "important");
    });

    const helpTipContent = document.querySelectorAll('.t_Tooltip .border-box.content');
    helpTipContent.forEach((element)=>{
        element.style.setProperty("padding", `10px 17px 75px 70px`, "important");
    });


    if(isRtl){

      const whenToolTipLoaded = () => {
        return document.querySelector('.t_Tooltip') != null;
      }

      const adaptStylesRTLToolTip = () => {
        document.querySelector ('.t_Tooltip').classList.add("rtl");
        const helpTipContent = document.querySelectorAll('.t_Tooltip .border-box.content[style="display:none;"]');
        helpTipContent.forEach((element)=>{
        console.log('poo3');
            element.style.setProperty("padding", `10px 17px 75px 70px`, "important");
        });
      }

      doWhenReady({argument: '', condition: whenToolTipLoaded, callback: adaptStylesRTLToolTip, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})

    }

  }

  adaptStyleForRightPanelPostSlidingCitationToRight(){

    // console.count('adaptStyleForRightPanelPostSlidingCitationToRight');

    const whenProfileFaceContainerReady = () => document.querySelector(`#profile_facts_container`) != null;

    const adaptProfileFaceContainer = () => {

      // this.postSlidingCitationCount = 0;

      /*
        let computedTitleHeight = 0;
        const titleFact = document.querySelectorAll('#facts_description .strong');
        titleFact.forEach((element)=>{
            computedTitleHeight = getComputedDomValue({element, cssProp: 'height'})
        });
       */

      document.querySelector('#profile_facts_container').style.setProperty("height", `${window.innerHeight -  bottomSaveBarForMobileSourceCitation - 55/*  - computedTitleHeightcitation padding shiftdown */}px`, "important");
      document.querySelector('#profile_facts_container').style.setProperty("max-height", "initial", "important");

      const factsGroupTabs = document.querySelectorAll('button.source_group_tab');
      factsGroupTabs.forEach((element)=>{
          element.style.setProperty("padding", "11px 30px");
          element.style.setProperty("font-size", "15px");
          element.style.setProperty("box-sizing", "border-box");
          element.style.setProperty("width", "45%");
          element.style.setProperty("height", "50px");
          element.style.setProperty("border-top-left-radius", "10px");
          element.style.setProperty("border-top-right-radius", "10px");
      });

      document.querySelector('.super.button:not(#add-language-button):not(#quick_add_new_unmatched_button_child)').style.setProperty("padding", "7px 17px", "important");
      document.querySelector('.super.button:not(#add-language-button):not(#quick_add_new_unmatched_button_child)').style.setProperty("font-size", "18px", "important");

      document.querySelector('#selected_document_update_panel').style.setProperty("height", "85vh", "important");
      document.querySelector('#selected_document_update_panel > div').style.setProperty("height", "100%", "important");


      document.querySelector('#facts_module').style.setProperty("height", "100%", "important");
      document.querySelector('#form_cite_source').style.setProperty("height", "100%", "important");
      document.querySelector('.field.mtn.txt_mls').style.setProperty("height", "100%", "important");
      document.querySelector('.ptm.pbm').style.setProperty("height", "100%", "important");

      const factsLabels = document.querySelectorAll('.field_name_label');
      factsLabels.forEach((element)=>{
          element.style.setProperty("line-height", "19px");
          element.style.setProperty("font-size", "18px");
          element.style.setProperty("padding-top", "5px");
      });

      const profileLabels = document.querySelectorAll('#profile_facts_container label');
      profileLabels.forEach((element)=>{
          element.style.setProperty("line-height", "26px");
      });

      const relationshipLabels = document.querySelectorAll('#relationship_details_container label');
      relationshipLabels.forEach((element)=>{
          element.style.setProperty("line-height", "26px");
      });

      const partnersLabels = document.querySelectorAll('#partners_container label');
      partnersLabels.forEach((element)=>{
          element.style.setProperty("line-height", "26px");
      });

      const childrenLabels = document.querySelectorAll('#children_list label');
      childrenLabels.forEach((element)=>{
          element.style.setProperty("line-height", "26px");
      });

      if(isRtl){
        this.adaptRTLForCitations();
      }

      document.querySelector('#relationship_facts_container').style.setProperty("height", `${window.innerHeight -  bottomSaveBarForMobileSourceCitation - 55/* citation padding shiftdown */}px`, "important");
      document.querySelector('#relationship_facts_container').style.setProperty("max-height", "initial", "important");

      document.querySelector('#additional_information').style.setProperty("background", "white");

      // document.getElementById("debugDiv").innerHTML += `moo <br/>`;
      // document.getElementById("debugDiv").innerHTML += `valie: ${isSelectorValid('#all_relationships')} <br/>`;

      // if( isSelectorValid('#all_relationships')) document.querySelector('#all_relationships').style.setProperty("padding-left", `${window.innerWidth/50}px`, "important");
      // if( isSelectorValid('#all_relationships')) document.querySelector('#all_relationships').style.setProperty("padding-right", `${window.innerWidth/50}px`, "important");


      // document.getElementById("debugDiv").innerHTML += `foo <br/>`;

    }

    doWhenReady({argument: '', condition: whenProfileFaceContainerReady, callback: adaptProfileFaceContainer, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})

  }

  slideCitationOnRightPanel = false;

  slideCitationPanel({direction, toggle}){

    if(direction === 'right'){
      this.adaptStyleForRightPanelPostSlidingCitationToRight();
    }

    let going = undefined
    let translateX = 0
    if(typeof(toggle) !== 'undefined'){
      if(this.slideCitationOnRightPanel){
        going = 1;
        this.slideCitationOnRightPanel = false;
      } else {
        going = -1;
        this.slideCitationOnRightPanel = true;
      }
    } else {
      if(direction === 'right'){
        going = -1;
        this.slideCitationOnRightPanel = true;
        translateX = going * window.innerWidth;
        document.querySelector('.modal_lightbox').style.setProperty("transform", "translateY(-43px)");
      } else{
        this.slideCitationOnRightPanel = false;
        going = 1;
      }
    }

    let delay = 120;
    const duration = 490;


    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['.modal_lightbox'],
      translateX,
      translateY: this.translateYModalLightBox * -1,
    });

  }

  slideCitationUpForAndroidKeyboard = false;

  slideCitatioForAndroidKeyboard({direction, toggle}){

    const translateX = -1 * window.innerWidth;

    let going = undefined
    let translateY = 0
    if(typeof(toggle) !== 'undefined'){
      if(this.slideCitationUpForAndroidKeyboard){
        going = 1;
        this.slideCitationUpForAndroidKeyboard = false;
      } else {
        going = -1;
        this.slideCitationUpForAndroidKeyboard = true;
      }
    } else {
      if(direction === 'up'){
        going = -1;
        this.slideCitationUpForAndroidKeyboard = true;
        translateY = going * (window.innerHeight/4 + 23);
      } else{
        this.slideCitationUpForAndroidKeyboard = false;
        going = 1;
      }
    }

    let delay = 120;
    const duration = 490;

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['.modal_lightbox'],
      translateX,
      translateY,
    });

  }

  autoLaunchDecisionPanel(){

    const addExistObj = {
    "floater_profile_id": "94315",
    "focusPrid": "6000000023252214790",
    "dropOnNode": "4",
    "dropOnPrId": "6000000023252214790",
    "floaterFirstName": "Fred",
    "floaterGender": "m",
    "node": "4"
    };

    this.setAddExistObj(addExistObj) // move.js. 306
    const screenIsOn = `relationshipDeciderFromFloat`;
    this.setFlipCardScreenIsOn({screenIsOn});
    this.showMobileFlipCard();

    // this.refs[this.highlightNodeRef.ref].touchPic();
    // this.userTouchedWithCallback();

    const node = this.highlightNodeRef.node;
    this.setShowMobileFlipCard(node);
    const pr_id = this.nodeObjs[node].pr_id;
    this.props.fetchFlipData({pr_id, node});

  }

  autoLaunchFlipCard(node){
    node = ( typeof(node) !== 'undefined' ? node: this.props.focusNode)
    this.setNodeForFlipFocus(node);
    this.setShowMobileFlipCard(node);
    const screenIsOn = `mainFromHome`;
    this.setFlipCardScreenIsOn({screenIsOn});

  }

  autoLaunchNavGotoListMobile(){
    const screenIsOn = `navListFromTree`;
    this.setFlipCardScreenIsOn({screenIsOn});
    this.showMobileFlipCard();
    setTimeout(() => {
      this.fetchEveryProfile();
    }, 1000);
  }

  autoLaunchLegendListMobile(){
    const screenIsOn = `navLegendFromTree`;
    this.setFlipCardScreenIsOn({screenIsOn});
    this.showMobileFlipCard();
  }

  autoLaunchMoreMobile(node){
    node = ( typeof(node) !== 'undefined' ? node: this.props.focusNode)
    this.setNodeForFlipFocus(node);
    this.setShowMobileFlipCard(node);
    // const screenIsOn = ``;
    // this.setFlipCardScreenIsOn({screenIsOn});
    // setTimeout(() => {
    //   console.log('moreFromMain');
    //   const screenIsOn = `moreFromMain`;
    //   this.setFlipCardScreenIsOn({screenIsOn});
    // }, 2000);
  }

  autoLaunchPrintCardMobile(){
    const screenIsOn = `printCardFromTree`;
    this.setFlipCardScreenIsOn({screenIsOn});
    this.showMobileFlipCard();
  }

  getRenderSlideUpImmediateFam(){

    return (

          <SlideUpImmediateFam
            immediateFamVersion='flipCard'
            disableClick={true}
            clickforImmediateFamily={this.clickforImmediateFamily.bind(this)}
            slideUpImmediatePanel={this.slideUpImmediatePanel.bind(this)}
            translatedLabels={this.translatedLabels}
            toggleFlipPanel={this.toggleFlipPanel.bind(this)}
            setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
            addNodeFormFocus={this.state.nodeForFlipFocus}
            chartType={this.props.chartType}
            nodeObjs={this.props.nodeObjs}
          />

    )
  }

  getRenderSlideUpAddSourceCitation(){

    return (


          <SlideUpAddSourceCitation
            disableClick={true}
            slideUpAddSourceCitationPanel={this.slideUpAddSourceCitationPanel.bind(this)}
            translatedLabels={this.translatedLabels}
            setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
            nodeObjs={this.nodeObjs}
            nodeForFlipFocus={this.state.nodeForFlipFocus}
          />

    )
  }

  getRenderPreferencesMobile(){

    return (


      <PreferencesMobile
        chartType={this.props.chartType}
        modalOpen={this.state.modalOpen}
        nodeObjs={this.nodeObjs}
        nodeForFlipFocus={this.state.nodeForFlipFocus}
        whichModalScreen={this.state.whichModalScreen}
        hideModal={this.hideModal.bind(this)}
        postPreferences={this.props.postPreferences}
        preferences={this.props.preferences}
        fetchPreferences={this.props.fetchPreferences}
        translatedLabels={this.translatedLabels}
      />

    )
  }

  getConfirmMobile(){

    return (

         <ConfirmMobile
            setShowConfirmMobile={this.setShowConfirmMobile.bind(this)}
            onMobileConfirm={this.state.onMobileConfirm}
            onMobileOk={this.state.onMobileOk}
            showConfirmMobile={this.state.showConfirmMobile}
            mobileConfirmContent={this.state.mobileConfirmContent}
            mobileConfirmLabel={this.state.mobileConfirmLabel}
            mobileOkLabel={this.state.mobileOkLabel}
         />

    )
  }

  getPrintFlipcardMobile(){

    const {
      flipData,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    const props = {
      flipData,
      canvasHeight,
    };

    return (

         <PrintFlipcardMobile
            {...props}
            placeholderImage_m={this.state.placeholderImage_m}
            placeholderImage_f={this.state.placeholderImage_f}
            placeholderImage_u={this.state.placeholderImage_u}
            nodeObjs={this.nodeObjs}
            unions={this.unions}
            focusNode={this.props.focusNode}
            nodeCount={this.props.nodeCount}
            canvasHeight={this.props.canvasHeight}
            canvasWidth={this.props.canvasWidth}
            printModalVisible={this.state.printModalVisible}
            setPrintModalVisible={this.setPrintModalVisible.bind(this)}
            createImageElementForProfilePic={this.createImageElementForProfilePic.bind(this)}
            gatherNodesToFetchMoreData={this.gatherNodesToFetchMoreData.bind(this)}
            getEdgeOfTree={this.getEdgeOfTree.bind(this)}
            fetchIt={this.fetchIt.bind(this)}
            nodeNeedsFetchProfiles={this.nodeNeedsFetchProfiles.bind(this)}
            nodeIsDeadPerson={this.nodeIsDeadPerson.bind(this)}
            rightEdgeOfTree = {this.props.edges.get('right')}
            date_format = {this.props.preferences.get('date_format')}
            translatedLabels={this.translatedLabels}
            lowerPrintRes = {this.props.preferences.get('lowerPrintRes')} // printTreeResolution SuperTweak
            scalePrintCanvas = {this.props.preferences.get('scalePrintCanvas')} // printTreeResolution SuperTweak
          />

    )
  }

  getMobileTouchIcons(){

    const {
      canvasTop,
      canvasWidth,
      flipData,
      isFanChart,
      chartType,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    // if(isMobilePhone()) canvasHeight += 10;

    const props = {
      flipData,
      canvasWidth,
      canvasHeight,
      canvasTop,
      isFanChart,
      chartType,
    };

    // const mobileButtonDim = 34;
    let mobileFocusButtonStyle  = {
      position: 'absolute',
      top: `${ this.props.canvasHeight - 60 }px`,
      left: `10px`,
      width: mobileButtonDim + 'px',
      height: mobileButtonDim + 'px',
      background: `url(${imageBasePath}bullseye.svg) no-repeat `,
      backgroundSize: `${mobileButtonDim}px ${mobileButtonDim}px`,
      opacity: .4,
    };

    let mobileNavGotoListStyle  = {
      position: 'absolute',
      top: `${ this.props.canvasHeight - 110 }px`,
      left: `10px`,
      width: mobileButtonDim + 'px',
      height: mobileButtonDim + 'px',
      background: `url(${imageBasePath}list.svg) no-repeat `,
      backgroundSize: `${mobileButtonDim}px ${mobileButtonDim}px`,
      opacity: .4,
    };

    return (

        <Fragment>
          <div
            style={mobileFocusButtonStyle}
            onClick={()=>{
              if( this.props.chartType === 'fan' ){
                this.gotoFanChartCenter();
              } else {
                this.gotoFocusNode({});
              }
            }}
          ></div>

          {

            this.props.chartType === 'default'

            ?

              <div
                id={"mobileNavGotoList"}
                style={mobileNavGotoListStyle}
                onClick={()=>{
                  this.hideNotificationModal({});
                  const screenIsOn = `navListFromTree`;
                  this.setFlipCardScreenIsOn({screenIsOn});
                  this.showMobileFlipCard();
                  setTimeout(() => {
                    this.fetchEveryProfile();
                  }, 1000);

                }}
              ></div>

            :

            null

          }
          {

              <SwitchTree
                  {...props}
                  switchTree={this.switchTree.bind(this)}
                  switchTreeTo={this.switchTreeTo.bind(this)}
                  isPedigreeDev={this.state.isPedigreeDev}
                  showSwitchOtherIcons={this.state.showSwitchOtherIcons}
                  toggleNavigationalPanel={this.toggleNavigationalPanel.bind(this)}
                  resetNavigationState={this.resetNavigationState.bind(this)}
                  setShowSwitchOtherIcons={this.setShowSwitchOtherIcons.bind(this)}
                  maxAncestorGen={this.props.maxAncestorGen}
                  isPedigree={this.props.isPedigree}
                  clearImgCache={this.state.clearImgCache}
              />
          }

          {

            ( (showPrintTree === 'true' && this.state.treeIsVisable)  || isDevelopment  || isSeinfeld) // bookmarkPleaseRemove PrintTreeIcon

            ?

                <PrintTreeIcon // Mobile
                    {...props}
                    stagePrintCurrent={this.stage.current}
                    ancestors={this.props.preferences.get('ancestors')}
                    maxAncestorGen={this.props.maxAncestorGen}
                    nodeObjs={this.props.nodeObjs}
                    focusNode={ this.props.chartType === 'fan' ? this.props.fanChartData.node.n: this.props.focusNode}
                    fanchartCurrent={this.fanChartComponent.current}
                    renderStageCanvasToImg={this.renderStageCanvasToImg.bind(this)}
                    setPrintModalVisible={this.setPrintModalVisible.bind(this)}
                    hideProductTour={this.hideProductTour.bind(this)}
                    setStagePrintDownloadingTo={this.setStagePrintDownloadingTo.bind(this)}
                    clearImgCache={this.state.clearImgCache}
                />

             :

             null
          }

          {

            ( !this.props.isPedigree  && this.state.treeIsVisable && !minimal)

            ?


                <HelpIcon
                  {...props}
                  chartType={this.props.chartType}
                  setShowLegendModal={this.setShowLegendModal.bind(this)}
                  gotoFocusNode={this.gotoFocusNode.bind(this)}
                  hideNotificationModal={this.hideNotificationModal.bind(this)}
                  setFlipCardScreenIsOn={this.setFlipCardScreenIsOn.bind(this)}
                  showMobileFlipCard={this.showMobileFlipCard.bind(this)}
                  toggleProductTour={this.toggleProductTour.bind(this)}
                />

             :

              null
          }

        </Fragment>

    )
  }

  getRenderFlipCardMobile(){

        const {
          canvasTop,
          canvasWidth,
          flipData,
          isPedigree,
          setPrId,
          fetchTree,
          fetchFlipData,
        } = this.props;

        let {
          canvasHeight,
        } = this.props;

        if( hasTreeActivationBanner || hasExpiringProUpsell ){
          canvasHeight += 60;
        }

        const props = {
          flipData,
          canvasWidth,
          canvasHeight,
          canvasTop,
          isPedigree,
        };


        return (

          <div>
            <Flipcard
              {...props}
              setPrId={setPrId}
              placeholderImage_m={this.state.placeholderImage_m}
              fetchLegendDescriptions={this.props.fetchLegendDescriptions}
              legendDescriptions={this.props.legendDescriptions}
              showHookMessageForNearbyTreeMatches={this.showHookMessageForNearbyTreeMatches.bind(this)}
              showHookMessageNeedForReload={this.showHookMessageNeedForReload.bind(this)}
              allProfilesFetched={this.state.allProfilesFetched}
              translateUsingLn={this.translateUsingLn.bind(this)}
              translateUsingMdn={this.translateUsingMdn.bind(this)}
              preferences={this.props.preferences}
              cidsGrps={this.props.cidsGrps}
              prepareGotoNavData={this.prepareGotoNavData.bind(this)}
              storePrIdToLocationHistory={this.storePrIdToLocationHistory.bind(this)}
              panAnimateToNode={this.panAnimateToNode.bind(this)}
              gotoFanChartCenter={this.gotoFanChartCenter.bind(this)}
              chartType={this.props.chartType}
              panAndHighlight={this.panAndHighlight.bind(this)}
              setPushToHistory={this.setPushToHistory.bind(this)}
              resetFlipNodeCrumbs={this.resetFlipNodeCrumbs.bind(this)}
              removeFlipNodeCrumb={this.removeFlipNodeCrumb.bind(this)}
              inverseFlipNodeCrumb={this.inverseFlipNodeCrumb.bind(this)}
              changeFlipNodeCrumbs={this.changeFlipNodeCrumbs.bind(this)}
              createImageElementForProfilePic={this.createImageElementForProfilePic.bind(this)}
              unsetNodeForFlipFocus={this.unsetNodeForFlipFocus.bind(this)}
              clickforImmediateFamily={this.clickforImmediateFamily.bind(this)}
              setShowSlideUpImmediateFamily={this.setShowSlideUpImmediateFamily.bind(this)}
              setShowSlideUpAddSourceCitation={this.setShowSlideUpAddSourceCitation.bind(this)}
              toggleFlipPanel={this.toggleFlipPanel.bind(this)}
              setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
              addNodeFormFocus={this.state.nodeForFlipFocus}
              nodeObjs={this.props.nodeObjs}
              setShowFloaterPanel={this.setShowFloaterPanel.bind(this)}
              lookUpPrId={this.props.lookUpPrId}
              lookUpNodeId={this.props.lookUpNodeId}
              unions={this.props.unions}
              floaterExist={this.floaterExist.bind(this)}
              redraw={this.redraw.bind(this)}
              addFloater={this.addFloater.bind(this)}
              postToServer={this.postToServer.bind(this)}
              unhighlight={this.unhighlight.bind(this)}
              fetchProfiles={this.props.fetchProfiles}
              fetchImmediateFamily={this.props.fetchImmediateFamily}
              buildChoicesArray={this.buildChoicesArray.bind(this)}
              decisionChoicesArray={this.decisionChoicesArray}
              addExistObj={this.state.addExistObj}
              callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
              postInvite={this.props.postInvite}
              flipCardScreenIsOn={this.state.flipCardScreenIsOn}
              fetchTree={fetchTree}
              fetchFlipData={fetchFlipData}
              callSetPageProfile={this.callSetPageProfile.bind(this)}
              stopStageClickPropagation={this.stopStageClickPropagation.bind(this)}
              fetchFlipMoreFilter={this.props.fetchFlipMoreFilter}
              showProgressIndicator={this.showProgressIndicator.bind(this)}
              showTreeOverlay={this.showTreeOverlay.bind(this)}
              setDidRequestLoadTreeToTrue={this.setDidRequestLoadTreeToTrue.bind(this)}
              setNextNodeForPruning={this.setNextNodeForPruning.bind(this)}
              zoomOutFromMobileFlipCard={this.zoomOutFromMobileFlipCard.bind(this)}
              disableStageDragging={this.disableStageDragging.bind(this)}
              nodeForFlipFocus={this.state.nodeForFlipFocus}
              flipNodeCrumbs={this.state.flipNodeCrumbs}
              focusNode={this.props.focusNode}
              translatedLabels={this.translatedLabels}
              nodeIsDeadPerson={this.nodeIsDeadPerson.bind(this)}
              nodeIsPresumedDeadPerson={this.nodeIsPresumedDeadPerson.bind(this)}
              setShowMobileFlipCard={this.setShowMobileFlipCard.bind(this)}
              unsetShowMobileFlipCard={this.unsetShowMobileFlipCard.bind(this)}
              setFlipCardScreenIsOn={this.setFlipCardScreenIsOn.bind(this)}
              zoomBackToLevelBeforeClick={this.zoomBackToLevelBeforeClick.bind(this)}
              setShowPrintMobile={this.setShowPrintMobile.bind(this)}
              refocusFanChart={this.refocusFanChart.bind(this)}
              enableTouchmove={this.enableTouchmove.bind(this)}
            />
          </div>

        )

      //   return (

      // )


  }
}




export default Mobile;
